import * as z from 'zod/mini';

export const PackagePeriodRequestSchema = z.object({
  package_id: z.number(),
  locale: z.string(),
  office_id: z.number(),
  department_id: z.number(),
});

export const PackagePeriodResponseSchema = z.object({
  price_period: z.nullish(z.object({
    start_date: z.string(),
    end_date: z.string(),
  })),
  synced_at: z.nullish(z.string()),
});
